var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-rect',{ref:"arcFaceTwo",attrs:{"config":_vm.config},on:{"click":_vm.onClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }